// NOTE Вспомогательные функции для иморта в компоненты или methods

const capitalize = str => str[0].toUpperCase() + str.substring(1)

const formatOkved = str => {
    if(str) {
        str = str[0].toUpperCase() + str.substring(1).toLowerCase();
    }
    return str;
}

const formatCode = str => {
    if (str) {
        str = str.split(":")[1]
    }
    return str;
}

const getQueryStringValue = key =>
    decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + encodeURIComponent(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1"))

const date_format = (date, type) => {
    let dt = new Date(date)
    if (!dt.valueOf()) return date

    let str_date = `${dt.getDate() * 1 < 10 ? `0${dt.getDate()}` : dt.getDate()}`
    let str_year = dt.getFullYear()
    if (!type) {
        let realMonth = dt.getMonth() + 1
        let str_month = `${realMonth < 10 ? `0${realMonth}` : realMonth}`
        return `${str_date}.${str_month}.${str_year}`;
    } else {
        const months = [ 'января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря' ]
        let realMonth = dt.getMonth() + 1
        let str_month = months[realMonth]
        return `${str_date} ${str_month} ${str_year}`;
    }
}

const lowerButFirst = function(str:string):string {
    return str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : str
}

const lowerButFirstSentence = function(str:string):string {
    return str.split(' ').map(lowerButFirst).join(' ')
}

const getStatusIcon = function(status_id:string, text):string {
    text = text || ["Ликвидированное", "Действующее", "В стадии ликвидации", "Статус не определен"];

    switch (status_id.toString()) {
        case '0':
            return '<span style="color: #e74c3c;cursor: help;" title="' + text[0] + '"><i class="uk-icon-times-circle"></i></span>';
        case '1':
            return '<span style="color: #2ecc71;cursor: help;" title="' + text[1] + '"><i class="uk-icon-check-circle"></i></span>';
        case '3':
            return '<span style="color: #2ecc71;cursor: help;" title="' + text[1] + '"><i class="uk-icon-check-circle"></i></span>';
        case '2':
            return '<span style="color: #e7843c;cursor: help;" title="' + text[2] + '"><i class="uk-icon-minus-circle"></i></span>';
        default:
            return '<span style="color: #ddd;cursor: help;" title="' + text[3] + '"><i class="uk-icon-circle-o"></i></span>';
    }
}

const statusTypeText = function(status_type) {
    switch (status_type) {
        case 0:
            return 'ликвидировано'
        case 1:
            return 'зарегистрировано'
        case 2:
            return 'в стадии ликвидации'
        case 3:
            return 'зарегистрировано'
    }
}

const moneyFormat = function(n, decimal_places) {
    if (isNaN(parseFloat(n))) {
        return n;
    }

    if (decimal_places) {
        return parseFloat(n).toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1 ").replace('.', ',');
    }

    return parseFloat(n).toFixed().replace(/(\d)(?=(\d{3})+(,|$))/g, '$1 ');
}

const translit = function(text) {
    var arrru = new Array ('Я','я','Ю','ю','Ч','ч','Ш','ш','Щ','щ','Ж','ж','А','а','Б','б','В','в','Г','г','Д','д','Е','е','Ё','ё','З','з','И','и','Й','й','К','к','Л','л','М','м','Н','н', 'О','о','П','п','Р','р','С','с','Т','т','У','у','Ф','ф','Х','х','Ц','ц','Ы','ы','Ь','ь','Ъ','ъ','Э','э')
    var arren = new Array ('Ya','ya','Yu','yu','Ch','ch','Sh','sh','Sh','sh','Zh','zh','A','a','B','b','V','v','G','g','D','d','E','e','E','e','Z','z','I','i','J','j','K','k','L','l','M','m','N','n', 'O','o','P','p','R','r','S','s','T','t','U','u','F','f','H','h','C','c','Y','y','`','`','\'','\'','E', 'e')
    
    for(var i = 0; i < arrru.length; i++){
        const reg = new RegExp(arrru[i], "g")
		text = text.replace(reg, arren[i])
    }

	return text
}

const htmlStringToPrint = function (title, html, style) {
    return `
        <!DOCTYPE html>
        <html>
            <head>
                <title>${title}</title>
                <meta charset="utf-8">
                <link rel="stylesheet" type="text/css" href="/assets/lib/uikit/css/uikit.gradient.min.css" />
                <link rel="stylesheet" href="https://use.fontawesome.com/releases/v5.4.1/css/all.css" integrity="sha384-5sAR7xN1Nv6T6+dT2mhtzEpVJvfS3NScPQTrOxhwjIuvcA67KV2R5Jz6kr4abQsz" crossorigin="anonymous">
                <style>
                    html, body {
                        font-family: "Lucida Sans Unicode", "Lucida Grande", Sans-Serif;
                    }
                    #print-pdf-hint {
                        font-family: sans-serif;
                        font-size: 20px;
                        border-radius: 15px;
                        background-color: 
                        #ddddde;
                        padding: 25px;
                        line-height: 28px;
                        border: 3px dashed
                        #eee;
                    }
                    #print-main-title {
                        border-bottom: 1px solid #4b6365;
                        color: #4b6365;
                        font-size: 25px;
                        margin-top: 0px;
                        margin-bottom: 0px;
                        text-align: center;
                        margin-bottom: 15px;
                        margin-top: 20px;

                    }
                    ul {
                        list-style-type: none;
                    }
                    ul.affiliantion-modal-list {
                        padding-top: 15px;
                        padding-bottom: 15px;
                    }
                    ul.affiliantion-modal-list:nth-child(2n) {
                        background: #eee;

                    }
                    ${style}
                </style>
            </head>
            <body bgcolor="white" style="width: 100%; max-width: 960px; margin: 20px auto; font-size: 14px;">
                <h2 class="print-main-title">${title}</h2>
                <div id="print-content">${html}</div>
            </body>
        </html>
    `
}

const getHoursAndMinutesFomDateObjectString = dateObject => {
    const date = new Date(dateObject)
    const hrs = ("0" + date.getHours()).slice(-2)
    const minutes = ("0" + date.getMinutes()).slice(-2)
    return `${hrs}:${minutes}`
}
const correctFio = fio => fio.toLowerCase().split(' ').map(e => capitalize(e)).join(' ')
const detectIEEdge = () => {
    const ua = window.navigator.userAgent

    const msie = ua.indexOf('MSIE ')
    if (msie > 0) {
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10)
    }

    const trident = ua.indexOf('Trident/')
    if (trident > 0) {
        const rv = ua.indexOf('rv:')
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10)
    }

    const edge = ua.indexOf('Edge/')
    if (edge > 0) {
       // Edge => return version number
       return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10)
    }

    return false
}

const downloadBinaryFile = (binary, filename = 'download', format = 'pdf') => {
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = window.URL.createObjectURL(new Blob([binary]))
    link.download = `${filename}.${format}`
    document.body.appendChild(link)
    link.click()
    link.remove()
}

const Base64 = {
    // private property
    _keyStr : "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",
  
    // public method for encoding
    encode : function (input) {
        var output = "";
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0;
  
        input = Base64._utf8_encode(input);
  
        while (i < input.length) {
  
            chr1 = input.charCodeAt(i++);
            chr2 = input.charCodeAt(i++);
            chr3 = input.charCodeAt(i++);
  
            enc1 = chr1 >> 2;
            enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
            enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
            enc4 = chr3 & 63;
  
            if (isNaN(chr2)) {
                enc3 = enc4 = 64;
            } else if (isNaN(chr3)) {
                enc4 = 64;
            }
  
            output = output +
            this._keyStr.charAt(enc1) + this._keyStr.charAt(enc2) +
            this._keyStr.charAt(enc3) + this._keyStr.charAt(enc4);
  
        }
  
        return output;
    },
  
    // public method for decoding
    decode : function (input) {
        var output = "";
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0;
  
        input = input.replace(/[^A-Za-z0-9\+\/\=]/g, "");
  
        while (i < input.length) {
  
            enc1 = this._keyStr.indexOf(input.charAt(i++));
            enc2 = this._keyStr.indexOf(input.charAt(i++));
            enc3 = this._keyStr.indexOf(input.charAt(i++));
            enc4 = this._keyStr.indexOf(input.charAt(i++));
  
            chr1 = (enc1 << 2) | (enc2 >> 4);
            chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
            chr3 = ((enc3 & 3) << 6) | enc4;
  
            output = output + String.fromCharCode(chr1);
  
            if (enc3 != 64) {
                output = output + String.fromCharCode(chr2);
            }
            if (enc4 != 64) {
                output = output + String.fromCharCode(chr3);
            }
  
        }
  
        output = Base64._utf8_decode(output);
  
        return output;
  
    },
  
    // private method for UTF-8 encoding
    _utf8_encode : function (string) {
        string = string.replace(/\r\n/g,"\n");
        var utftext = "";
  
        for (var n = 0; n < string.length; n++) {
  
            var c = string.charCodeAt(n);
  
            if (c < 128) {
                utftext += String.fromCharCode(c);
            } else if((c > 127) && (c < 2048)) {
                utftext += String.fromCharCode((c >> 6) | 192);
                utftext += String.fromCharCode((c & 63) | 128);
            } else {
                utftext += String.fromCharCode((c >> 12) | 224);
                utftext += String.fromCharCode(((c >> 6) & 63) | 128);
                utftext += String.fromCharCode((c & 63) | 128);
            }
  
        }
  
        return utftext;
    },
  
    // private method for UTF-8 decoding
    _utf8_decode : function (utftext) {
        var string = ""
        var i = 0
        var c = 0
        // var c1 = 0
        var c2 = 0
        var c3 = 0
  
        while ( i < utftext.length ) {
  
            c = utftext.charCodeAt(i);
  
            if (c < 128) {
                string += String.fromCharCode(c);
                i++;
            } else if((c > 191) && (c < 224)) {
                c2 = utftext.charCodeAt(i+1);
                string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
                i += 2;
            } else {
                c2 = utftext.charCodeAt(i+1);
                c3 = utftext.charCodeAt(i+2);
                string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
                i += 3;
            }
        }
  
        return string;
    }
}

const dateParser = (date) => {
    const reg = /^\d{2}\.\d{2}\.\d{4}$/gm
    if(reg.test(date)) return date
    return new Date(date).toLocaleDateString('ru')
}

const capitalizeFirstLetter = (str) => {
    str = str.toLowerCase()
    const res = str[0].toUpperCase() + str.substring(1, str.length)
    return res
}

const getRussianCodeName = (code, type) => {
    switch(code) {
        case 'ogrn':
            return type === 'ip' ? 'ОГРНИП' : 'ОГРН'
        case 'inn':
            return 'ИНН'
        case 'okpo':
            return 'ОКПО'
        case 'kpp':
            return 'КПП'
        case 'okato':
            return 'ОКАТО'
        case 'oktmo': 
            return 'ОКТМО'
        case 'okved':
            return 'ОКВЭД'
        case 'okfs':
            return 'ОКФС'
        case 'okopf':
            return 'ОКОПФ'
        case 'fss':
            return 'ФСС'
        case 'pf':
            return 'ПФР'
        default:
            return 'КОД'
    }
}

const firstCapitalLetter = name => name.toLowerCase().split(' ').map(word => word[0].toUpperCase() + word.slice(1)).join(' ')

const downloadByUrl = url => {
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    link.click()
}

const getPercent = (num, total) => Math.round(num/total * 100)

const getImgFromCanvas = (canvas, container) => {
    if(canvas) {
        const img = document.createElement('img')
        img.src = canvas.toDataURL('image/png')
        img.style.width = `${canvas.offsetWidth}px`
        img.style.height = `${canvas.offsetHeight}px`    
        container.appendChild(img)
    }
}

const cutTable = (srcTable: HTMLTableElement, firstIndex: number, lastIndex: number): string => {
    if(srcTable) {
        const rows = Array.from(srcTable.rows)
        const targetTable = `
            <table class="${Array.from(srcTable.classList).join(' ')}">
                ${rows.map(r => {
                    return `
                        <tr class="${Array.from(r.classList).join(' ')}">
                            ${ Array.from(r.cells).map((c,i) => {
                                if(!(i >= firstIndex && i <= lastIndex)) {
                                    return `
                                        <${c.nodeName.toLocaleLowerCase()} class="${Array.from(c.classList).join(' ')}">
                                            ${c.innerText}
                                        </${c.nodeName.toLocaleLowerCase()}>
                                    `
                                }
                            }).join('')}
                        </tr>
                    `
                }).join('')}
            </table>
        `
        return targetTable
    } else {
        return ''
    }
}
const capitalizeButFirst = str => str.split(' ').map(word => word.at(0).toUpperCase() + word.slice(1).toLowerCase()).join(' ')

// экспорт для { htmlStringToPrint } таргетированного импорта
export {
    htmlStringToPrint,
    translit,
    getQueryStringValue,
    detectIEEdge,
    downloadBinaryFile,
    dateParser,
    Base64,
    capitalizeFirstLetter,
    getRussianCodeName,
    firstCapitalLetter,
    downloadByUrl,
    capitalizeButFirst,
    getPercent,
    getImgFromCanvas,
    cutTable,
    correctFio
}

// экспорт для helpers общего импорта
export default {
    getHoursAndMinutesFomDateObjectString,
    moneyFormat,
    statusTypeText,
    getStatusIcon,
    lowerButFirst,
    formatOkved,
    formatCode,
    getQueryStringValue,
    date_format,
    capitalize,
    dateParser,
    lowerButFirstSentence,
    capitalizeFirstLetter,
    getRussianCodeName,
    firstCapitalLetter,
    downloadByUrl,
    capitalizeButFirst,
    getPercent,
    getImgFromCanvas,
    cutTable,
    correctFio
}